/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { HolderRequest } from "../model"
// @ts-ignore
import type { NoubaHolder } from "../model"
// @ts-ignore
import type { UpdateContactRoleBeneficiaireRequest } from "../model"
// @ts-ignore
import type { UpdateHolderRequest } from "../model"
/**
 * HolderResourceApi - axios parameter creator
 */
export const HolderResourceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get project\'s holder
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHolder: async (
      projectId: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("getHolder", "projectId", projectId)
      const localVarPath = `/{projectId}/holders`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get project\'s nouba holders
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNoubaHolders: async (
      projectId: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("getNoubaHolders", "projectId", projectId)
      const localVarPath = `/{projectId}/holders-nouba`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update nouba holder\'s contact role
     * @param {number} projectId
     * @param {string} holderId
     * @param {UpdateContactRoleBeneficiaireRequest} updateContactRoleBeneficiaireRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateContactRoleBeneficiaire: async (
      projectId: number,
      holderId: string,
      updateContactRoleBeneficiaireRequest: UpdateContactRoleBeneficiaireRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("updateContactRoleBeneficiaire", "projectId", projectId)
      // verify required parameter 'holderId' is not null or undefined
      assertParamExists("updateContactRoleBeneficiaire", "holderId", holderId)
      // verify required parameter 'updateContactRoleBeneficiaireRequest' is not null or undefined
      assertParamExists(
        "updateContactRoleBeneficiaire",
        "updateContactRoleBeneficiaireRequest",
        updateContactRoleBeneficiaireRequest
      )
      const localVarPath = `/{projectId}/holders-nouba/{holderId}/contactRoleBeneficiaire`
        .replace("{projectId}", encodeURIComponent(String(projectId)))
        .replace("{holderId}", encodeURIComponent(String(holderId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateContactRoleBeneficiaireRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Sauvegarde les informations relatives à l\'accès plus du porteur
     * @param {number} projectId
     * @param {string} holderId
     * @param {HolderRequest} holderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHolder: async (
      projectId: number,
      holderId: string,
      holderRequest: HolderRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("updateHolder", "projectId", projectId)
      // verify required parameter 'holderId' is not null or undefined
      assertParamExists("updateHolder", "holderId", holderId)
      // verify required parameter 'holderRequest' is not null or undefined
      assertParamExists("updateHolder", "holderRequest", holderRequest)
      const localVarPath = `/{projectId}/holders/{holderId}`
        .replace("{projectId}", encodeURIComponent(String(projectId)))
        .replace("{holderId}", encodeURIComponent(String(holderId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        holderRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update nouba holder
     * @param {number} projectId
     * @param {string} holderId
     * @param {UpdateHolderRequest} updateHolderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateNoubaHolder: async (
      projectId: number,
      holderId: string,
      updateHolderRequest: UpdateHolderRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("updateNoubaHolder", "projectId", projectId)
      // verify required parameter 'holderId' is not null or undefined
      assertParamExists("updateNoubaHolder", "holderId", holderId)
      // verify required parameter 'updateHolderRequest' is not null or undefined
      assertParamExists("updateNoubaHolder", "updateHolderRequest", updateHolderRequest)
      const localVarPath = `/{projectId}/holders-nouba/{holderId}`
        .replace("{projectId}", encodeURIComponent(String(projectId)))
        .replace("{holderId}", encodeURIComponent(String(holderId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateHolderRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * HolderResourceApi - functional programming interface
 */
export const HolderResourceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = HolderResourceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get project\'s holder
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHolder(
      projectId: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HolderRequest>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getHolder(projectId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["HolderResourceApi.getHolder"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get project\'s nouba holders
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getNoubaHolders(
      projectId: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NoubaHolder>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getNoubaHolders(projectId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["HolderResourceApi.getNoubaHolders"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update nouba holder\'s contact role
     * @param {number} projectId
     * @param {string} holderId
     * @param {UpdateContactRoleBeneficiaireRequest} updateContactRoleBeneficiaireRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateContactRoleBeneficiaire(
      projectId: number,
      holderId: string,
      updateContactRoleBeneficiaireRequest: UpdateContactRoleBeneficiaireRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoubaHolder>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateContactRoleBeneficiaire(
        projectId,
        holderId,
        updateContactRoleBeneficiaireRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["HolderResourceApi.updateContactRoleBeneficiaire"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Sauvegarde les informations relatives à l\'accès plus du porteur
     * @param {number} projectId
     * @param {string} holderId
     * @param {HolderRequest} holderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateHolder(
      projectId: number,
      holderId: string,
      holderRequest: HolderRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HolderRequest>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateHolder(
        projectId,
        holderId,
        holderRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["HolderResourceApi.updateHolder"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update nouba holder
     * @param {number} projectId
     * @param {string} holderId
     * @param {UpdateHolderRequest} updateHolderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateNoubaHolder(
      projectId: number,
      holderId: string,
      updateHolderRequest: UpdateHolderRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoubaHolder>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateNoubaHolder(
        projectId,
        holderId,
        updateHolderRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["HolderResourceApi.updateNoubaHolder"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * HolderResourceApi - factory interface
 */
export const HolderResourceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = HolderResourceApiFp(configuration)
  return {
    /**
     *
     * @summary Get project\'s holder
     * @param {HolderResourceApiGetHolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHolder(
      requestParameters: HolderResourceApiGetHolderRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<HolderRequest>> {
      return localVarFp
        .getHolder(requestParameters.projectId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get project\'s nouba holders
     * @param {HolderResourceApiGetNoubaHoldersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNoubaHolders(
      requestParameters: HolderResourceApiGetNoubaHoldersRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<NoubaHolder>> {
      return localVarFp
        .getNoubaHolders(requestParameters.projectId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update nouba holder\'s contact role
     * @param {HolderResourceApiUpdateContactRoleBeneficiaireRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateContactRoleBeneficiaire(
      requestParameters: HolderResourceApiUpdateContactRoleBeneficiaireRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<NoubaHolder> {
      return localVarFp
        .updateContactRoleBeneficiaire(
          requestParameters.projectId,
          requestParameters.holderId,
          requestParameters.updateContactRoleBeneficiaireRequest,
          options
        )
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Sauvegarde les informations relatives à l\'accès plus du porteur
     * @param {HolderResourceApiUpdateHolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHolder(
      requestParameters: HolderResourceApiUpdateHolderRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<HolderRequest> {
      return localVarFp
        .updateHolder(
          requestParameters.projectId,
          requestParameters.holderId,
          requestParameters.holderRequest,
          options
        )
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update nouba holder
     * @param {HolderResourceApiUpdateNoubaHolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateNoubaHolder(
      requestParameters: HolderResourceApiUpdateNoubaHolderRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<NoubaHolder> {
      return localVarFp
        .updateNoubaHolder(
          requestParameters.projectId,
          requestParameters.holderId,
          requestParameters.updateHolderRequest,
          options
        )
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for getHolder operation in HolderResourceApi.
 */
export interface HolderResourceApiGetHolderRequest {
  readonly projectId: number
}

/**
 * Request parameters for getNoubaHolders operation in HolderResourceApi.
 */
export interface HolderResourceApiGetNoubaHoldersRequest {
  readonly projectId: number
}

/**
 * Request parameters for updateContactRoleBeneficiaire operation in HolderResourceApi.
 */
export interface HolderResourceApiUpdateContactRoleBeneficiaireRequest {
  readonly projectId: number

  readonly holderId: string

  readonly updateContactRoleBeneficiaireRequest: UpdateContactRoleBeneficiaireRequest
}

/**
 * Request parameters for updateHolder operation in HolderResourceApi.
 */
export interface HolderResourceApiUpdateHolderRequest {
  readonly projectId: number

  readonly holderId: string

  readonly holderRequest: HolderRequest
}

/**
 * Request parameters for updateNoubaHolder operation in HolderResourceApi.
 */
export interface HolderResourceApiUpdateNoubaHolderRequest {
  readonly projectId: number

  readonly holderId: string

  readonly updateHolderRequest: UpdateHolderRequest
}

/**
 * HolderResourceApi - object-oriented interface
 */
export class HolderResourceApi extends BaseAPI {
  /**
   *
   * @summary Get project\'s holder
   * @param {HolderResourceApiGetHolderRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getHolder(
    requestParameters: HolderResourceApiGetHolderRequest,
    options?: RawAxiosRequestConfig
  ) {
    return HolderResourceApiFp(this.configuration)
      .getHolder(requestParameters.projectId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get project\'s nouba holders
   * @param {HolderResourceApiGetNoubaHoldersRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getNoubaHolders(
    requestParameters: HolderResourceApiGetNoubaHoldersRequest,
    options?: RawAxiosRequestConfig
  ) {
    return HolderResourceApiFp(this.configuration)
      .getNoubaHolders(requestParameters.projectId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update nouba holder\'s contact role
   * @param {HolderResourceApiUpdateContactRoleBeneficiaireRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateContactRoleBeneficiaire(
    requestParameters: HolderResourceApiUpdateContactRoleBeneficiaireRequest,
    options?: RawAxiosRequestConfig
  ) {
    return HolderResourceApiFp(this.configuration)
      .updateContactRoleBeneficiaire(
        requestParameters.projectId,
        requestParameters.holderId,
        requestParameters.updateContactRoleBeneficiaireRequest,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Sauvegarde les informations relatives à l\'accès plus du porteur
   * @param {HolderResourceApiUpdateHolderRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateHolder(
    requestParameters: HolderResourceApiUpdateHolderRequest,
    options?: RawAxiosRequestConfig
  ) {
    return HolderResourceApiFp(this.configuration)
      .updateHolder(
        requestParameters.projectId,
        requestParameters.holderId,
        requestParameters.holderRequest,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update nouba holder
   * @param {HolderResourceApiUpdateNoubaHolderRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateNoubaHolder(
    requestParameters: HolderResourceApiUpdateNoubaHolderRequest,
    options?: RawAxiosRequestConfig
  ) {
    return HolderResourceApiFp(this.configuration)
      .updateNoubaHolder(
        requestParameters.projectId,
        requestParameters.holderId,
        requestParameters.updateHolderRequest,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }
}
